import { createSlice } from '@reduxjs/toolkit';

// Estado UI del drawer global de vinculación SAT (SatLinkingDrawer, montado en
// SessionShell): reintento desde la barra fiscal en "linking_failed" o
// vinculación fresca desde el CTA del drawer de info fiscal.
//
// El RESULTADO del intento (fallo, mensaje, código) NO vive aquí: es del
// workflow (useLinkingWorkflow, persistido en storage) y se consume vía
// useSATConnection. El fallo no abre avisos automáticos — la señal pasiva es
// el banner fiscal en rojo.
export interface SATLinkingUIState {
	linkingDrawerOpen: boolean;
}

const initialState: SATLinkingUIState = {
	linkingDrawerOpen: false,
};

export const satLinkingUISlice = createSlice({
	name: 'satLinkingUI',
	initialState,
	reducers: {
		openLinkingDrawer: (state) => {
			state.linkingDrawerOpen = true;
		},
		closeLinkingDrawer: (state) => {
			state.linkingDrawerOpen = false;
		},
	},
});

export const { openLinkingDrawer, closeLinkingDrawer } =
	satLinkingUISlice.actions;
